import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Error } from '@mui/icons-material';
import { DateUtils } from '../../../utils/DateUtils.js';
import './index.css';
import MuiTableHeader from '../../../uiComponents/MuiTable/MuiTableHeader';
import MuiTablePagination from '../../../uiComponents/MuiTable/MuiTablePagination';
import {stableSort, getComparator} from '../../../uiComponents/MuiTable/MuiHelper';
import { StyledPaper, StyledTable, StyledTableRow, StyledTableCell } from '../../../uiComponents/MuiTable/StyledTable.js';
import { 
  TableBody,
  TableContainer,
} from '@mui/material';

const headCells = [
  { label: 'Variant Name', id: 'variant.variantName', numeric: false, disablePadding: false },
  { label: 'Date Assigned', id: 'dateAssigned', numeric: false, disablePadding: false }, //won't sort correctly due to response structure
  { label: 'Date Completed', id: 'dateCompleted', numeric: false, disablePadding: false }, //won't sort correctly due to response structure
  { label: 'Status', id: 'variantInterpretation.status', numeric: false, disablePadding: false },
];

const InterpretationsTable = ({ data }) => {
  const [breadCrumbs, setBreadCrumbs] = useState([]);
  const [summary, setSummary] = useState({});
  const [programId, setProgramId] = useState(null);
  const [tableData, setTableData] = useState(data);
  const [order, setOrder] = useState('desc'); //default sort direction
  const [orderBy, setOrderBy] = useState('variant.variantName'); //default sort column for table
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const assignmentStatusCell = (row) => {
    const linkState = {
      summary: summary,
      breadCrumbs: breadCrumbs,
      programId: programId,
      variantId: row.variant.variantObjectId,
      variantName: row.variant.variantName,
      variantReviewId: row.interpretation.variantReviewId,
      gene: row.variant.geneId,
      variantInterpretationId: row.interpretation.variantInterpretationId
    };

    switch (row.interpretation.interpretationStatus) {
      case "New":
        return (
          <div>
            <RouterLink 
              to='/addinterpretation/'
              state={linkState}
            >
              New<Error style={{ fontSize: '1.1rem', verticalAlign: 'middle', marginLeft: '3px', marginTop: '-2px' }}  className="exclamation" />
            </RouterLink>
          </div>
        );
      case "Completed":
        return <div>{row.interpretation.interpretationStatus}</div>;
      default:
        return (
          <RouterLink 
            to='/addinterpretation/'
            state={linkState}
          >
            {row.interpretation.interpretationStatus}
          </RouterLink>
        );
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
      setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
  };

  return (
    <>
        <StyledPaper>
        <TableContainer>
          <StyledTable
            size='small'
            aria-label="assigned interpretations table" >
            <MuiTableHeader 
              headCells={headCells} 
              order={order}  
              orderBy={orderBy} 
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {stableSort(tableData, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                return (
                  <StyledTableRow tabIndex={-1} key={index}>
                    <StyledTableCell>{row.variant.variantName}</StyledTableCell>
                    <StyledTableCell>{DateUtils.FormatLocalDate(row.assignedDate)}</StyledTableCell>
                    <StyledTableCell>{DateUtils.FormatLocalDate(row.completedDate)}</StyledTableCell>                    
                    <StyledTableCell>{assignmentStatusCell(row)}</StyledTableCell>
                  </StyledTableRow>
                );
              })}
            </TableBody>
          </StyledTable>
        </TableContainer>
        <MuiTablePagination 
          rowsPerPage={rowsPerPage}
          page={page}
          count={tableData.length}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage} 
        />
      </StyledPaper>
    </>
  );
};

export default InterpretationsTable;